import { render, staticRenderFns } from "./ShippingStatusComponent.vue?vue&type=template&id=330ba383&"
import script from "./ShippingStatusComponent.vue?vue&type=script&lang=js&"
export * from "./ShippingStatusComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports